import styled from 'styled-components';

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  h3 {
    font-size: 1.15rem;
    font-weight: 700;
    color: var(--gray-shade-30);
    margin: 0;
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const NetValue = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--blue-base);
`;

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
  padding-top: 4px;
`;

export const MetaItem = styled.div`
  background: var(--gray-90);
  border: 1px solid var(--gray-80);
  border-radius: 5px;
  padding: 8px 12px;
`;

export const MetaLabel = styled.div`
  font-size: 10.5px;
  color: var(--gray-30);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 3px;
`;

export const MetaValue = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-shade-30);
`;

export const TabContent = styled.div`
  padding: 16px 4px 4px;
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--gray-20);
  margin: 18px 0 8px;

  &:first-child {
    margin-top: 0;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
`;

export const InfoCell = styled.div`
  background: var(--gray-90);
  border: 1px solid var(--gray-80);
  border-radius: 5px;
  padding: 8px 12px;
`;

export const InfoLabel = styled.div`
  font-size: 10.5px;
  color: var(--gray-30);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 3px;
`;

export const InfoValue = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-shade-30);
`;

export const ProductTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th {
    text-align: left;
    font-size: 10.5px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--gray-30);
    font-weight: 600;
    padding: 8px 10px;
    border-bottom: 2px solid var(--gray-80);
  }

  td {
    padding: 8px 10px;
    border-bottom: 1px solid var(--gray-80);
    color: var(--gray-shade-30);
  }

  tbody tr:hover {
    background: var(--gray-90);
  }
`;

export const SelfServiceTag = styled.span`
  background: var(--blue-90);
  color: var(--blue-base);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
`;

export const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: var(--gray-40);
  font-size: 13px;
`;

export const LoadingBox = styled.div`
  padding: 40px;
  text-align: center;
  color: var(--gray-40);
  font-size: 13px;
`;

export const SummaryGrid = styled.div`
  max-width: 320px;
  margin-left: auto;
`;

export const SummaryLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 12.5px;
  color: var(--gray-20);
`;

export const TotalLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 0;
  margin-top: 6px;
  border-top: 2px solid var(--gray-80);
  font-size: 15px;
  font-weight: 800;
  color: var(--blue-base);
`;
